import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
    password: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .required('Password is required'),
});

export const signUpSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, 'Name is too short')
        .max(50, 'Name is too long')
        .required('Name is required'),
    email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
    password: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .required('Password is required'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm password is required'),
    ageVerified: Yup.boolean()
        .oneOf([true], 'You must be at least 13 years old')
        .required('Required'),
});

export const productSchema = Yup.object().shape({
    productName: Yup.string().required('Product name is required'),
    brandName: Yup.string().required('Brand name is required'),
    category: Yup.string().required('Category is required'),
    price: Yup.number().positive('Price must be positive').required('Price is required'),
    sellingPrice: Yup.number()
        .positive('Selling price must be positive')
        .lessThan(Yup.ref('price'), 'Selling price must be less than original price')
        .required('Selling price is required'),
    stock: Yup.number().integer('Stock must be an integer').min(0, 'Stock cannot be negative').required('Stock is required'),
    description: Yup.string().required('Description is required'),
});
